import Tabs from "ui/components/Tabs";
import ContentPanel from "./components/ContentPanel";

interface PanelPrevisaoOrcamentariaProps {
  loading?: boolean;
  receita: {
    previsto: number;
    realizado: number;
    saldo: number;
  };
  despesa: {
    previsto: number;
    realizado: number;
    saldo: number;
  };
}

export default function PanelPrevisaoOrcamentaria({
  loading,
  receita,
  despesa,
}: PanelPrevisaoOrcamentariaProps) {
  return (
    <Tabs.Tab
      containerProps={{
        padding: 5,
        roundedBottom: 16,
        width: "100%",
      }}
    >
      <Tabs.Panel title={"Despesa"}>
        <>
          <ContentPanel loading={loading} {...despesa} />
        </>
      </Tabs.Panel>
      <Tabs.Panel title={"Receita"}>
        <>
          <ContentPanel loading={loading} {...receita} />
        </>
      </Tabs.Panel>
    </Tabs.Tab>
  );
}
